import LoginForm from "../../Components/LoginForm/LoginForm"
import useTitle from "../../hooks/useTitle";
import './Authorization.scss';

export default function Authorization() {
    useTitle("Авторизация");
    return (
        <main className="auth-page">
            <div className="_container">
                <LoginForm />
            </div>
        </main>
    )
}